import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c267a890"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-350" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-delete-title" }, "Edit Question to", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-delete-question-name" }, " Select Questions that you want to update for partner ", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "align-items-center justify-content-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-delete-question-name" }, " Keep answers to questions ? ", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This process takes a few minutes to save and update. During this "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" time it will not be possible to edit and you won't see your saved changes")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("On the dashboard, located on the Partner title the icon below "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" indicates your edits are being configured. When the icon is not "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" displayed the configuration is completed.")
], -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_gray_text = _resolveComponent("gray-text")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_modal, { "is-visible": _ctx.isOpen }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_DropDown, { class: "mb-32 w-100" }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentOption.name), 1)
            ]),
            list: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option.name,
                  onClick: ($event: any) => (_ctx.setOption(option))
                }, _toDisplayString(option.name), 9, _hoisted_4))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_DropDown, {
            class: "mb-32 w-100",
            style: _normalizeStyle({
          borderRadius: '6px',
          border: _ctx.storeKeepAnswer === null && _ctx.updateQuestionWasSubmitted ? '1px solid red' : '',
        })
          }, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.storeKeepAnswer === null ?
                  'Select...'
                  : _ctx.storeKeepAnswer ?
                    'Keep answer' :
                    'Delete answer'), 1)
            ]),
            list: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setKeepAnswer(true)))
              }, "Keep answer"),
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setKeepAnswer(false)))
              }, "Delete answer")
            ]),
            _: 1
          }, 8, ["style"]),
          (_ctx.storeKeepAnswer === false)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_gray_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("'Type DELETE' to confirm delete answers.")
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deleteValue) = $event)),
                  class: "input-confirm-delete",
                  type: "text",
                  placeholder: "DELETE"
                }, null, 512), [
                  [_vModelText, _ctx.deleteValue]
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          class: "mx-1",
          disabled: !_ctx.canUpdateQuestion,
          variant: "base",
          onClick: _ctx.onEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode("Update")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_base_button, {
          class: "mx-1",
          variant: "outlined",
          onClick: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(_component_the_modal, { "is-visible": _ctx.questionCreateConfirmIsOpen }, {
      content: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.currentOption.id === _ctx.CREATE_QUESTION_ALL_PARTNER_ID || _ctx.currentOption.id === _ctx.CREATE_QUESTION_SELECT_PARTNER_ID)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("b", null, "The edits " + _toDisplayString(_ctx.currentOption.placeholderName) + " are being configured.", 1),
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("img", {
                  class: "processing-icon",
                  src: require('@/assets/img/process.png'),
                  alt: "processing",
                  width: "24",
                  height: "24"
                }, null, 8, _hoisted_10)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, "Your question has been Edited " + _toDisplayString(_ctx.currentOption.placeholderName) + ".", 1))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.currentOption.id === _ctx.CREATE_QUESTION_CURRENT_PARTNER_ID ? 'Back to Dashboard' : 'I understand, back to dashboard'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-visible"])
  ], 64))
}